import { Control, Controller, useWatch } from 'react-hook-form';

import { TextField } from '@/components/shared/TextField/TextField';
import { ExploreBlockType } from '@addmile/backend-client';

import { BlockFormData } from '../schema';

type QuizDetailsFieldProps = {
  control: Control<BlockFormData>;
};

export const QuizDetailsField = ({ control }: QuizDetailsFieldProps) => {
  const type = useWatch({ control, name: 'type' });
  if (type !== ExploreBlockType.Quiz) return null;
  return (
    <div>
      <label className="block text-sm font-semibold text-neutral-70 mb-2">Details (JSON)</label>
      <Controller
        name="details"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            isTextArea
            placeholder='{"results":[], "questions": 0, "duration": {"value": 0, "unit": "min"}}'
            className="!w-full"
            inputClassName="!border !border-neutral-20 !font-medium font-mono min-h-[20vh]"
          />
        )}
      />
    </div>
  );
};

export default QuizDetailsField;
